import { Launch as LaunchIcon } from '@mui/icons-material';
import { Divider, Grid, Typography, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import HttpServices from 'src/services/httpService';
import { postsModuleURL } from 'src/services/urlService';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import blueskyIcon from '../../../assets/bluesky.svg';   // Add your Bluesky icon
import { useTranslation } from 'react-i18next';


import BlueskyPostCard from '../publishedPostsPostCard/BlueskyPostCard.component';

const BlueskyPostDetailView = ({ pageId, postId, profile, height }) => {
    const { t: translate } = useTranslation();
  const [postDetails, setPostDetails] = useState(null);
  const [showLoader, setLoader] = useState(true);
  const { showToast } = useToaster();

  useEffect(() => {
    getPostDetails();
  }, []);

  const successCallback = (data) => {
    const pDetails = {
      id: data.id,
      media_urls: data.media_urls,
      description: data.message,
      like_count: data.like_count,
      reply_count: data.reply_count,
      bookmark_count: data.bookmark_count,
      repost_count: data.repost_count,
      created_time: data.created_time,
      link: data.link,
    };
    setPostDetails(pDetails);
    setLoader(false);
  };

  const failureCallback = (message) => {
    setPostDetails(null);
    showToast(message, 'e');
    setLoader(false);
  };

  const getPostDetails = () => {
    setLoader(true);
    const getProps = {
      url: `${postsModuleURL.getBlueskyPostDetails}${pageId}&post_id=${postId}`,
      successCallback,
      failureCallback,
    };
    HttpServices.Get(getProps);
  };

  const postContent = () => {
    if (!postDetails) return null;

    const cardDetails = {
      media_urls: postDetails.media_urls,
      description: postDetails.description,
      like_count: postDetails.like_count,
      reply_count: postDetails.reply_count,
      bookmark_count: postDetails.bookmark_count,
      repost_count: postDetails.repost_count,
      profile,
    };
    return <BlueskyPostCard {...cardDetails} />;
  };

  return (
    <StyledComponent.StyledStack sx={{ width: 800 }}>
      <Box sx={{ position: 'fixed', width: 800, zIndex: 1000, background: 'white' }}>
        <Grid alignItems="center" display="flex" sx={{ pt: 1, pb: 1 }}>
          <img alt="Bluesky" width={75} height={40} src={blueskyIcon} />
          <Typography color="#000000" sx={{ fontSize: 25, fontWeight: 800, ml: 1 }}>
            {translate('bluesky_published_post.bluesky')}
          </Typography>
          {postDetails?.link && (
            <a href={postDetails.link} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 'auto' }}>
              <LaunchIcon sx={{ fontSize: '2rem', mr: 2, color: 'primary.main' }} />
            </a>
          )}
        </Grid>
        <Divider />
      </Box>

      <Box sx={{ mt: '5.6rem' }}>
        {showLoader ? (
            <Spinner height={height} />
          ) : (
            <>
              <Grid display="flex" alignItems="flex-start" justifyContent="flex-start" sx={{ ml: '1.5rem !important' }}>
                {postContent()}
              </Grid>
            </>
          )}
      </Box>
    </StyledComponent.StyledStack>
  );
};

export default BlueskyPostDetailView;